import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth, onAuthStateChanged } from "../firebase";
import { DirectLine } from "botframework-directlinejs";
import ReactWebChat, { createStore } from "botframework-webchat";
import { URL } from "../urls";
import Footer from "./Footer";
import Header from "./Header";

const DigitalLab = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [chatConfig, setChatConfig] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (!user) {
        navigate("/dashboard"); // Redirect to dashboard if not authenticated
      } else {
        setUser(user);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, [navigate]);

  useEffect(() => {
    const fetchToken = async () => {
      try {
        const response = await fetch(URL.GET_TOKEN_DIGITAL);
        const data = await response.json();
        if (data.token) {
          const directLine = new DirectLine({ token: data.token });

          // Create store to inject welcome message when chat connects
          const store = createStore(
            {},
            ({ dispatch }) =>
              (next) =>
              (action) => {
                if (action.type === "DIRECT_LINE/CONNECT_FULFILLED") {
                  // Welcome message intentionally simplified,
                  // description is shown below the title instead
                }
                return next(action);
              }
          );

          setChatConfig({ directLine, store });
        } else {
          console.error("Error: No token received.");
        }
      } catch (error) {
        console.error("Failed to fetch token:", error);
      }
    };

    fetchToken();
  }, []);

  const handleLogout = async () => {
    try {
      await auth.signOut();
      navigate("/");
    } catch (err) {
      console.error("Logout error:", err);
    }
  };

  if (loading) return <div>Loading...</div>;
  if (!user) return null;

  return (
    <div className="chatbot-container chat-fit-screen">
      <Header />
      <h1 className="chatbot-title">SLT Digital Lab Internship Q&amp;A</h1>
      <p
        style={{
          marginTop: "-6px",
          marginBottom: "14px",
          color: "rgba(255,255,255,0.85)",
          textAlign: "center",
          fontSize: "16px",
          maxWidth: "780px",
          width: "92%",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        Guide you through SLT's Digital Lab internship program with ease.
      </p>

      <div
        style={{
          width: "80%",
          height: "calc(100dvh - 340px)",
          minHeight: "320px",
          borderRadius: "15px",
          overflow: "hidden",
        }}
      >
        {chatConfig ? (
          <ReactWebChat
            directLine={chatConfig.directLine}
            store={chatConfig.store}
            style={{ height: "100%" }}
          />
        ) : (
          <p>Loading Chatbot...</p>
        )}
      </div>

      <button className="Btn" onClick={handleLogout}>
        <div className="sign">
          <svg viewBox="0 0 512 512">
            <path d="M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z"></path>
          </svg>
        </div>
        <div className="text">Logout</div>
      </button>
      <Footer />
    </div>
  );
};

export default DigitalLab;
